module.exports = __webpack_public_path__ + "static/media/logo.efeae133.svg";